import { render, staticRenderFns } from "./editOverMoney.vue?vue&type=template&id=6ba6bdc6&scoped=true"
import script from "./editOverMoney.vue?vue&type=script&lang=js"
export * from "./editOverMoney.vue?vue&type=script&lang=js"
import style0 from "./editOverMoney.vue?vue&type=style&index=0&id=6ba6bdc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6bdc6",
  null
  
)

export default component.exports